import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { DragHandler } from '../../pages/Tasks/DragHandler'
import {  CmdKeyIcon, CollapseIcon, FullscreenIcon, SettingsIcon } from '../LandingHeader/Feedback/icons/Icons'
import ChatGPTModal from '../../pages/Settings/Modal/ChatGPTModal'
import { getKeyboardSymbol, isMac } from '../action/utilities'

const AIAssistantWidget = ({defaultMaximize = false}) => {
    const {theme} = useSelector(state => state.theme)
    const [quoteCollapse, setQuoteCollapse] = useState(true);
    const navigate = useNavigate();
    const [chatGPTModal, setChatGPTModal] = useState(false);
    const settings = useSelector(state => state.settings.settings)

    const toggleMinMax = (e) => {
        e.preventDefault();

        if(defaultMaximize){
            navigate(process.env.REACT_APP_ROOT)
        }else{
            navigate('/ai-assistant')
        }
    }

    return (
        <div className='bar aiAssistant'>
            {
                quoteCollapse 
                ?
                <div className="dailyQuote">
                    
                    <div id="chat-gpt-widget" className="quoteContainer">
                        <div className={`quoteInner widgetWrapper pb-5`}>
                            <DragHandler />
                            <div className='post-prompt-wrapper relative flex items-center'>
                                <textarea readOnly placeholder={'Ask AI ...'} type="text" className="prompt-input chatTextarea !h-[18px] placeholder:text-black dark:placeholder:text-white text-black dark:text-white" onClick={() => setChatGPTModal(true)}>
                                </textarea>
                                {
                                    typeof settings.keyboardShortcuts == 'undefined' || settings?.keyboardShortcuts?.openAssistant?.length > 0
                                    ?
                                    <span className="shortcut">{settings?.keyboardShortcuts?.openAssistant?.length > 0 ? settings?.keyboardShortcuts?.openAssistant.map(item => getKeyboardSymbol(item, true)).join(' ') : (isMac ? <><CmdKeyIcon /> L</> : ['Ctrl', 'L'].map(item => getKeyboardSymbol(item, true)).join(' '))}</span>
                                    :
                                    null
                                }
                            </div>
                        </div>
                    </div>

                    <div className='onHoverShorts aiAssist'>
                        <div className='actOnhove'>
                            <div className='hovAct ht-collapse' onClick={() => setQuoteCollapse(false)}> <CollapseIcon color={theme == 'dark' ? 'gray' : 'black'} /> </div>
                            <div className='hovAct ht-scale' onClick={toggleMinMax}> <FullscreenIcon color={theme == 'dark' ? 'gray' : 'black'} /> </div>
                            <div className='hovAct ht-settings' onClick={() => navigate(`/settings#cards:ai`) }> <SettingsIcon color={theme == 'dark' ? 'gray' : 'black'} /> </div>
                        </div>
                    </div>
                </div> 
                : 
                <div className='barContent' onClick={() => setQuoteCollapse(true)}>
                    <div className='barContentHeading'>
                        <h4 className='barHead'>AI Assistant</h4>
                        <span className='headBrk'></span>
                    </div>
                </div>
            }
            {
                chatGPTModal && <ChatGPTModal onHide={() => setChatGPTModal(false)} />
            }
        </div>
    )
}

export default AIAssistantWidget